import React from 'react';
import {DataItem} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import FormInput from 'src/hook-form-wrapper/form-input';
import {useTranslations} from 'src/providers/translation';

interface DisplayProps {
  value: string;
}

interface Props {
  name?: string;
  required?: boolean;
}

export const Import = (
  key: string = 'title',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Title',
  key,
  validators: [
    {
      validate: 'required',
    },
  ],
});

export const Value = (value: string) => {
  return value;
};

export const Display = ({value}: DisplayProps) => {
  const translations = useTranslations();

  return (
    <DataItem>
      <Text style={[Typography.H6]}>{translations('auth_form_title')}</Text>
      <Text style={[Typography.P3]}>{Value(value)}</Text>
    </DataItem>
  );
};

export const Input = ({name, required = false}: Props) => {
  const translations = useTranslations();

  return (
    <FormInput
      name={(name ? name + '.' : '') + 'title'}
      label={translations('auth_form_title')}
      placeholder={translations('auth_form_title')}
      helper={''}
      required={required}
    />
  );
};

export const validation = () => Yup.string().required('Title is required');

export default Input;
